import {
  DEBUGGER_RECEIVE_EVENT,
  DEBUGGER_RECEIVE_HISTORICAL_EVENT,
  DEBUGGER_RECEIVE_ERROR,
  DEBUGGER_RECEIVE_HISTORICAL_ERROR,
  DEBUGGER_TICK,
  DEBUGGER_PAUSED,
  DEBUGGER_RESUMED,
  DEBUGGER_SET_MEMORY_LIMIT,
  DEBUGGER_DESTROYED,
  DEBUGGER_LOADED
} from 'actions'

export const initialState = {
  // events that were received between "ticks"
  pendingEvents: [],
  // rendered events
  events: [],
  // meta
  isPaused: false,
  max_events: 500,
  isLoading: true
}

export default function(state = initialState, { type, payload }) {
  const { pendingEvents, events } = state
  const MAX_EVENTS = state.max_events
  const nextEvents = []

  switch (type) {
    case DEBUGGER_RECEIVE_EVENT:
      // when paused, don't accept new events
      if (state.isPaused) {
        return state
      }

      // remove the last event if we've reached our limit
      if (pendingEvents.length >= MAX_EVENTS) {
        pendingEvents.pop()
      }

      // add the pending event
      return {
        ...state,
        pendingEvents: [payload.event, ...pendingEvents]
      }
    case DEBUGGER_RECEIVE_HISTORICAL_EVENT:
      // immediately add historical events (make it look faster than it really is)
      nextEvents.push(payload.event)
      nextEvents.push(...events)
      return {
        ...state,
        events: nextEvents.slice(0, MAX_EVENTS)
      }

    case DEBUGGER_RECEIVE_HISTORICAL_ERROR:
    case DEBUGGER_RECEIVE_ERROR:
      return {
        ...state,
        pendingEvents: error(pendingEvents, payload.error),
        events: error(events, payload.error)
      }

    case DEBUGGER_TICK:
      // add new events + old events
      nextEvents.push(...pendingEvents)
      nextEvents.push(...events)
      return {
        ...state,
        // add the "next" events, keeping previous events (up to MAX_EVENTS)
        events: nextEvents.slice(0, MAX_EVENTS),
        // empty the pending bucket
        pendingEvents: []
      }
    case DEBUGGER_PAUSED:
      return { ...state, isPaused: true }
    case DEBUGGER_RESUMED:
      return { ...state, isPaused: false }
    case DEBUGGER_SET_MEMORY_LIMIT:
      return {
        ...state,
        max_events: parseInt(payload, 10)
      }
    case DEBUGGER_DESTROYED:
      return initialState
    case DEBUGGER_LOADED:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}

/**
 * Add `error` to the given `eventList`.
 * FIXME: I'm not immutable!
 */
function error(eventList, error) {
  const { messageId } = error
  // add to pending
  for (let i = 0; i < eventList.length; i++) {
    if (eventList[i].id === messageId) {
      eventList[i].errors.push(error)
    }
  }
  return eventList
}
